import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import RulesList from './RulesList';
import RulesCreate from './RulesCreate';
import RulesEdit from './RulesEdit';

function Rules() {
  const [activeTab, setActiveTab] = useState('list');
  const [selectedRule, setSelectedRule] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Tab configs
  const tabs = [
    {
      id: 'list',
      name: 'لیست قوانین',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      ),
      color: 'blue'
    },
    {
      id: 'create',
      name: 'ایجاد قانون',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      ),
      color: 'green'
    },
    {
      id: 'edit',
      name: 'ویرایش قانون',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      ),
      color: 'yellow'
    },
    // {
    //   id: 'delete',
    //   name: 'حذف قانون',
    //   icon: (
    //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    //     </svg>
    //   ),
    //   color: 'red'
    // }
  ];

  const getTabColor = (color, isActive) => {
    const colors = {
      blue: isActive ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30' : 'text-gray-400 hover:bg-gray-700 hover:text-white',
      green: isActive ? 'bg-green-600 text-white shadow-lg shadow-green-500/30' : 'text-gray-400 hover:bg-gray-700 hover:text-white',
      yellow: isActive ? 'bg-yellow-600 text-white shadow-lg shadow-yellow-500/30' : 'text-gray-400 hover:bg-gray-700 hover:text-white',
      red: isActive ? 'bg-red-600 text-white shadow-lg shadow-red-500/30' : 'text-gray-400 hover:bg-gray-700 hover:text-white'
    };
    return colors[color];
  };

  const handleEdit = (rule) => {
    setSelectedRule(rule);
    setActiveTab('edit');
  };

  const handleDelete = (rule) => {
    setSelectedRule(rule);
    setActiveTab('delete');
  };

  const handleSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
    setActiveTab('list');
    setSelectedRule(null);
  };

  const handleCancel = () => {
    setActiveTab('list');
    setSelectedRule(null);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'list':
        return <RulesList refreshTrigger={refreshTrigger} onEdit={handleEdit} onDelete={handleDelete} />;
      case 'create':
        return <RulesCreate onSuccess={handleSuccess} />;
      case 'edit':
        return <RulesEdit rule={selectedRule} onSuccess={handleSuccess} onCancel={handleCancel} />;
    //   case 'delete':
    //     return <RulesDelete rule={selectedRule} onSuccess={handleSuccess} onCancel={handleCancel} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex gap-6 h-full">
      {/* Sidebar */}
      <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        className="w-64 flex-shrink-0"
      >
        <div className="bg-gray-700/30 rounded-xl p-4 border border-gray-600 sticky top-6">
          <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
            <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
            </svg>
            مدیریت قوانین
          </h3>
          <div className="space-y-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-300 ${getTabColor(tab.color, activeTab === tab.id)}`}
              >
                {tab.icon}
                <span className="font-medium">{tab.name}</span>
              </button>
            ))}
          </div>
        </div>
      </motion.div>

      {/* Content */}
      <div className="flex-1">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {renderContent()}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default Rules;